import api from '../utils/api';

export const login = async (username, password) => {
    try {
        const response = await api.post('/auth/login', { username, password });

        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify({
                id: response.data.id,
                username: response.data.username,
                fullName: response.data.fullName,
                email: response.data.email,
                firstLogin: response.data.firstLogin,
                roles: response.data.roles
            }));
        }

        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Login failed');
    }
};

export const changePasswordFirstLogin = async (userId, oldPassword, newPassword) => {
    try {
        const response = await api.post('/auth/change-password-first-login', {
            userId,
            oldPassword,
            newPassword
        });

        if (response.data.token) {
            localStorage.setItem('token', response.data.token);

            // Update first login status in local storage
            const user = JSON.parse(localStorage.getItem('user'));
            user.firstLogin = false;
            localStorage.setItem('user', JSON.stringify(user));
        }

        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Password change failed');
    }
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

export const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
        return JSON.parse(userStr);
    }
    return null;
};

export const isAuthenticated = () => {
    return localStorage.getItem('token') != null;
};

export const isAdmin = () => {
    const user = getCurrentUser();
    return user && user.roles && user.roles.includes('ROLE_ADMIN');
};

export const isManager = () => {
    const user = getCurrentUser();
    return user && user.roles && (user.roles.includes('ROLE_ADMIN') || user.roles.includes('ROLE_MANAGER'));
};

export const isSalesRep = () => {
    const user = getCurrentUser();
    return user && user.roles && (user.roles.includes('ROLE_SALES_REP'));
};

export const isDistributor = () => {
    const user = getCurrentUser();
    return user && user.roles && (user.roles.includes('ROLE_DISTRIBUTOR'));
};

export const isFirstLogin = () => {
    const user = getCurrentUser();
    return user && user.firstLogin;
};